<template>
  <div>
    <mobile-upload-menu
      class="mobile-globe"
      v-if="$route.name === 'printOrder'"
    ></mobile-upload-menu>

    <section
      id="main-menu-container"
      :class="{
        'globe-container': $route.name !== 'home',
        filestore: rootStore.currentSection === 'filestore',
        printstore: rootStore.currentSection === 'printstore',
        'cart-ia-globe': hasProductOrder && $route.name !== 'home'
      }"
      :style="[
        rootStore.currentSection === 'printstore'
          ? {
              top: printStoreScrollTop + 'px'
            }
          : {}
      ]"
    >
      <transition name="home-btn">
        <home-button
          class="home-btn-container"
          v-show="$route.name !== 'home'"
        ></home-button>
      </transition>

      <section
        class="globe"
        :style="{
          backgroundColor: rootStore.globe.backgroundColor,
          color: rootStore.theme.subColor
        }"
      >
        <template v-if="rootStore.propositionsLoaded">
          <cart-globe
            v-if="
              rootStore.globe.type === 'cart' ||
              (hasProductOrder && !inQuoteOrder)
            "
          ></cart-globe>
          <printstore-globe
            v-else-if="rootStore.currentSection === 'printstore'"
          ></printstore-globe>
          <title-globe
            v-else-if="rootStore.globe.type === 'title'"
          ></title-globe>
          <upload-globe
            v-else
            :in-progress="inProgress"
            :progress="progress"
            :file-drag="fileDrag"
          ></upload-globe>
        </template>

        <transition name="globe-reveal">
          <div
            v-if="!rootStore.propositionsLoaded"
            class="globe-overlay"
            :style="{ backgroundColor: rootStore.globe.backgroundColor }"
          ></div>
        </transition>
      </section>

      <nav class="menu-items">
        <globe-menu-item
          v-for="proposition in rootStore.theme.propositions"
          :key="proposition.pid"
          :style="{
            'font-size': proposition.propTitleFontSize
          }"
          :bg-color="proposition.backgroundColor"
          :title-color="proposition.propTitleColor"
          :text-color="proposition.propTextColor"
          :pulse="proposition.pulse"
          v-show="proposition.pid"
          @action="selectItem(proposition)"
          :class="{ 'move-out': rootStore.globe.hideMenu }"
        >
          <span v-html="proposition.propTitle"></span>
          <template v-slot:sub
            ><span
              v-if="proposition.propText"
              v-html="proposition.propText"
            ></span>
          </template>
        </globe-menu-item>
      </nav>

      <sub-menu :sub-menu="subMenu" @select-item="selectItem"></sub-menu>
    </section>
  </div>
</template>

<script>
import InteractionMixin from '@/mixins/InteractionMixin'
import HomeButton from './children/HomeButton.vue'
import SubMenu from './children/SubMenu.vue'
import GlobeMenuItem from './children/GlobeMenuItem.vue'
import TitleGlobe from './children/TitleGlobe.vue'
import UploadGlobe from './children/UploadGlobe.vue'
import PrintstoreGlobe from './children/PrintstoreGlobe.vue'
import MobileUploadMenu from './children/MobileUploadMenu.vue'
import CartGlobe from './children/CartGlobe.vue'
import cloneDeep from 'lodash-es/cloneDeep'

export default {
  props: ['progress', 'fileDrag', 'inProgress'],
  mixins: [InteractionMixin],
  data() {
    return {
      closeMenuBackgroundColor: '',
      subMenu: {
        colors: {},
        items: []
      },
      home: false,
      fsDrag: false,
      subTextColor: '#ffffff',
      moveOut: false,
      printStoreScrollTop: ''
    }
  },
  components: {
    HomeButton,
    SubMenu,
    GlobeMenuItem,
    TitleGlobe,
    UploadGlobe,
    PrintstoreGlobe,
    MobileUploadMenu,
    CartGlobe
  },
  computed: {
    hasProductOrder() {
      return this.rootStore.interactions.some(
        (ia) => ia.destination === 'productOrder'
      )
    },
    inQuoteOrder() {
      return this.$route.matched.some((route) => route.name === 'quoteOrder')
    }
  },
  created() {
    setTimeout(() => {
      this.moveOut = true
    }, 5000)
  },
  mounted() {
    const appView = document.getElementById('app')
    appView.addEventListener('scroll', (event) => {
      if (this.rootStore.currentSection === 'printstore') {
        this.printStoreScrollTop = appView.scrollTop + 118 //118 = initial top position of globemenu
      }
    })
  },
  methods: {
    selectItem(proposition) {
      let _this = this

      let showIntro

      const prop = cloneDeep(proposition)

      const userLevel = this.rootStore.loggedIn
        ? this.rootStore.user.securityLevel
        : 0
      switch (prop.destinationType) {
        case 'menu':
          this.rootStore.globeSetMain(false)
          this.subMenu.colors.background = prop.backgroundColor
          this.subMenu.colors.text = prop.propTitleColor

          prop.menuItems.forEach((item, index) => {
            let propLevel = parseInt(item.securityLevel) || 0
            if (userLevel < propLevel) {
              prop.menuItems.splice(index, 1)
            }
          })

          if (prop.menuItems.length === 1) {
            this.startInteraction(prop.menuItems[0])
            return
          }

          _this.subMenu.items = prop.menuItems
          setTimeout(() => {
            _this.rootStore.globeSetSub(true)
          }, 300)
          break
        case 'interaction':
          //check intro

          /*  if (showIntro && (prop.alwaysShowIntro || !this.rootStore.loggedIn)) {
            this.$router.push({
              name: prop.introScreen,
              params: {
                proceedFn: function () {
                  _this.startInteraction(prop)
                }
              }
            })
            //            this.closeSub()
          } else { */
          this.startInteraction(prop)
          // }

          break
        case 'page':
          this.$router.push({ name: prop.destination })
          break
        case 'url':
          window.open(prop.destination, '_blank')
          break
      }

      function menuFn() {
        _this.$router.push({ name: 'home' })
        _this.subMenu.items = prop.menuItems
        setTimeout(() => {
          _this.rootStore.globeSetSub(true)
        }, 300)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@use '../../sass/helpers/_variables.scss' as *;
@use '../../sass/helpers/_mixins.scss' as *;

#main-menu-container {
  transition: all 0.25s, top 0s;
  position: absolute;
  left: calc(50vw - 200px);
  transform: scale(0.75);
  top: 44px;
  width: 400px;
  height: 480px;
  pointer-events: none;

  &.globe-container {
    display: none;
  }

  &.cart-ia-container {
    display: none;
  }
}

@supports (-webkit-touch-callout: none) {
  /* CSS specific to iOS devices */
  #main-menu-container.printstore {
    position: fixed;
    top: 118px !important;
  }
}

.home-btn-container {
  top: 59px;
  position: absolute;
  left: 40px;
  pointer-events: initial;
}

.globe {
  @include eclipse(247px);
  background-color: white;
  box-shadow: rgba(0, 0, 0, 0.23) 0px 8px 24px;
  margin-left: 18px;
  margin-top: 103px;
  position: relative;
  text-align: center;
  z-index: 1;
  pointer-events: initial;
}

/* Dekt de globe af zolang nog niet bekend is welke globe er hoort. Zelfde
   kleur als de globe zelf, dus je ziet alleen het wegfaden waarmee de juiste
   globe tevoorschijn komt. */
.globe-overlay {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background-color: white;
  z-index: 2;
  pointer-events: none;
}

.globe-reveal-leave-active {
  transition: opacity 0.25s ease-out;
}

.globe-reveal-leave-to {
  opacity: 0;
}

@media only screen and (min-width: 375px) {
  #main-menu-container {
    transform: scale(0.9);
    top: 70px;
  }
}

@media only screen and (min-width: 768px) {
  #main-menu-container {
    left: 0;
    top: max(calc(50vh - 261px), 110px);
  }
}

@media only screen and (min-width: 620px) {
  #main-menu-container {
    &.globe-container {
      display: block;
    }

    &.printstore {
      display: none;
    }

    &.cart-ia-globe {
      display: none;
    }
  }

  .mobile-globe {
    display: none;
  }
}

@media only screen and (min-width: 900px) {
  #main-menu-container {
    left: 25px;
  }
}

@media only screen and (min-width: 1024px) {
  #main-menu-container {
    transform: scale(1);
    left: 20px;
    //    top: min(50vh - 261px, 190px);
    top: max(50vh - 351px, 118px);

    &.cart-ia-globe {
      display: block;
    }
  }
}

@media only screen and (min-width: 620px) {
  #main-menu-container.globe-container {
    //top: -32px;
    top: -33px;
    left: -18px;
    transform: scale(0.9);

    .home-btn-container {
      display: none;
    }
  }
}

@media only screen and (min-width: 768px) {
  #main-menu-container.globe-container {
    /*  left: 38px;
  
    //z-index: 10;
    top: 45px;
    margin-left: -25px;
    transform: scale(1); */
  }
}

@media only screen and (min-width: 940px) {
  #main-menu-container.globe-container.printstore {
    display: block;
  }
}

@media only screen and (min-width: 1024px) {
  #main-menu-container.globe-container {
    .home-btn-container {
      display: block;
    }
    //top: min(50vh - 261px, 190px);
    top: max(50vh - 351px, 118px);
    margin-left: 0;
    left: 14px;
    transform: scale(1);
  }
}

@media only screen and (min-width: 1280px) {
  #main-menu-container.globe-container {
    margin-left: 0;
    left: 20px;
  }

  #main-menu-container.globe-container.filestore {
    margin-left: 0;
    left: 14px;
    top: 78px;
  }
}
</style>
